function parents(element: HTMLElement | null, selector: string): HTMLElement[] {
    const elements: HTMLElement[] = [];

    while (element && element instanceof HTMLElement) {
        if (!selector || element.matches(selector)) {
            elements.push(element);
        }

        element = element.parentElement;
    }

    return elements;
}

// ----------------------------------------------------------------------------

export default parents;
